<!--
 Created by Xuz on 2019/01/29.
 xuz[at]live[dot]cn
 第二步：指定岗位用户选择
 <p>
 Xuz on 2020/06/13.
 当只有一个人时，自动选中
 <p>
 Xuz on 2020/08/14.
 选中人员支持拖动排序
-->
<template>
    <div style="display: flex">
        <a-card class="wf-card wf-any-user-card" :bordered="false">
            <div class="wf-card-title">
                <img :src="$_c + 'app/workflow/img/xwf/n2.gif'"/> 下一步处理人
                <a-checkbox v-if="!bSingle" class="check-all" @change="onSelectAll">全选</a-checkbox>
            </div>
            <div class="wf-card-body">
                <div class="fx-select-panel" style="width:200px">
                    <template v-if="!bSingle">
                        <a-checkbox-group @change="onCheckboxUserChange" :value="selectedIds" style="width:180px">
                            <a-row v-for="pos in posData" :key="pos.id">
                                <div class="pos-title">
                                    <label><input type="checkbox" class="check-section" :value="pos.id" @click.stop="onSelectSectionUsers"/> {{pos.name}}</label>
                                </div>
                                <a-checkbox v-for="user in pos.extras.users" :key="'c' + user.id" :value="user.id">{{ user.name }}</a-checkbox>
                            </a-row>
                        </a-checkbox-group>
                    </template>
                    <template v-else>
                        <a-radio-group @change="onRadioUserChange" :value="selectedIds.length > 0 ? selectedIds[0] : ''" style="width:180px">
                            <a-row v-for="pos in posData" :key="pos.id">
                                <div class="pos-title" >{{pos.name}}</div>
                                <a-radio v-for="user in pos.extras.users" :key="'c' + user.id" :value="user.id">{{ user.name }}</a-radio>
                            </a-row>
                        </a-radio-group>
                    </template>
                </div>
            </div>
        </a-card>
        <a-card class="wf-card" :bordered="false" style="width:160px;padding-left:8px">
            <div class="wf-card-title"><img :src="$_c + 'app/workflow/img/xwf/n3.gif'"/> 已选择</div>
            <div class="wf-card-body">
              <div v-show="bOrder" style="background-color:#fff0f0;color:#ff7b7b;margin:-5px -5px 0 -5px;padding:4px 2px;text-align:center;">拖动名字调整顺序</div>
              <draggable element="ul" v-model="selectedData" :sort="bOrder" @start="drag=true" @end="drag=false" @change="onChangeOrder" class="any-user-selected">
                <li v-for="user in selectedData" :key="'s' + user.id">{{user.name}}</li>
              </draggable>
            </div>
        </a-card>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import { XWF } from '../XWF'

export default {
  name: 'NXTCustomPosUserSelector',
  components: {
    draggable
  },
  props: {
  },
  created () {
  },
  data () {
    return {
      wfType: null,
      bSingle: false,
      bOrder: false,
      bGroupSendMode: false,
      posData: [],
      userData: [],
      selectedData: [],
      selectedIds: []
    }
  },
  watch: {
  },
  methods: {
    update (wfType, routeData) {
      console.log('NXTCustomPosUserSelector')
      this.wfType = wfType
      this.bSingle = XWF.isSingleEmpSelect(wfType)
      this.bOrder = XWF.isOrderEmpSelect(wfType)
      this.bGroupSendMode = XWF.isGroupSendMode(wfType)

      if (this.bOrder) {
        // 显示手动排序提示
      }
      if (this.bGroupSendMode) {
        this.posData = routeData.poses
        this.userData = this.mapGroupUserData(routeData.poses)
      } else {
        this.posData = routeData.poses
        this.userData = this.mapUserData(routeData.poses)
      }

      if (routeData.poses.length === 1 && routeData.poses[0].extras.users.length === 1) {
        // 岗位只有一个，且其中的人也只有一个的话，自动选中
        // 可以复用单选点击功能，模拟一个 event 出来
        let e = { target: { value: routeData.poses[0].extras.users[0].id } }
        this.onRadioUserChange(e)
      }
    },
    getType () {
      return this.wfType
    },
    getSelected () {
      return this.selectedIds
    },
    onSelectAll (e) {
      let ids = []
      if (e.target.checked) {
        this.userData.forEach(function (item) {
          ids.push(item.id)
        })
      }
      this.onCheckboxUserChange(ids)
    },
    onSelectSectionUsers (e) {
      // console.log('current selected id: ' + this.selectedIds)
      let section = this.getSectionData(e.target.value)
      let ids = []
      section.extras.users.forEach(function (item) {
        ids.push(item.id)
      })
      let selectedIds = [...this.selectedIds]
      if (e.target.checked) {
        // 将用户添加到已选
        ids.forEach(itemId => {
          if (!selectedIds.includes(itemId)) {
            // 当前ID不在列表里，加入
            selectedIds.push(itemId)
          }
        })
      } else {
        // 将已选用户删除
        ids.forEach(itemId => {
          if (selectedIds.includes(itemId)) {
            // 当前ID在列表里，删除
            selectedIds = selectedIds.filter(value => value !== itemId)
          }
        })
      }
      // console.log('selected ids: ' + this.selectedIds)
      // console.log('final selected ids: ' + selectedIds)
      this.onCheckboxUserChange(selectedIds)
    },
    onCheckboxUserChange (checkedValues) {
      // console.log('onCheckboxUserChange:' + checkedValues)
      // 下面方法过滤出来的用户顺序是 userData 中的顺序，不是用户选择的顺序
      // this.selectedData = this.userData.filter(item => checkedValues.includes(item.id))
      this.selectedData = this.getSelectedData(checkedValues)
      this.selectedIds = [...checkedValues]

      this.$emit('change', this.selectedIds)
    },
    onRadioUserChange (e) {
      this.selectedData = this.userData.filter(item => item.id === e.target.value)
      this.selectedIds = [e.target.value]

      this.$emit('change', this.selectedIds)
    },
    onChangeOrder (e) {
      let selectedIds = []
      let selectedNames = []
      this.selectedData.forEach(function (item) {
        selectedIds.push(item.id)
        selectedNames.push(item.name)
      })
      this.selectedIds = selectedIds
      console.log('用户排序:' + selectedNames.join(', '))

      this.$emit('change', this.selectedIds)
    },
    mapUserData (poses) {
      let users = []

      poses.forEach(function (pos) {
        let tmp = pos.extras.users.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })

        users = [...users, ...tmp]
      })

      return users
    },
    mapGroupUserData (poses) {
      let users = []
      poses.forEach(function (pos) {
        let item = { id: pos.id, name: pos.deptName + '-' + pos.name }
        pos.extras.users = [item]
        users.push(item)
      })
      return users
    },
    getSectionData (sectionId) {
      for (let i = 0; i < this.posData.length; i++) {
        let item = this.posData[i]
        if (item.id === sectionId) {
          return item
        }
      }
      return null
    },
    getSelectedData (selectedIds) {
      let selectedData = []
      selectedIds.forEach(id => {
        selectedData = [...selectedData, ...this.userData.filter(item => item.id === id)]
      })
      return selectedData
    }
  }
}
</script>

<style scoped>
    .wf-any-user-container {
        width:420px;
        height:260px;
        overflow: auto;
        font-size: 14px;
        background: #fff;
    }

    .fx-select-panel {
        display: inline-block;
        vertical-align: top;
        border-right: 1px solid #e8e8e8;
        height: 260px;
        overflow-x: hidden;
    }

    .fx-select-panel:nth-last-child(1) {
        border-right: none;
    }

    .ant-tree > li:first-child {
        padding-top: 100px !important;
    }

    .ant-radio-group, .ant-checkbox-group {
        margin: 8px;
        margin-top: 0;
    }

    .ant-radio-wrapper, .ant-checkbox-wrapper {
        display: block;
        height: 24px;
        letter-spacing: 1.5px;
    }

    .ant-checkbox-wrapper {
        margin-left: 0;
    }

    .any-user-selected {
        margin: 0;
        padding: 0;
        list-style: none;
        letter-spacing: 1.5px;
    }

    .pos-title {
        background-color: #eeeeee;
        padding: 3px;
        color: #008000;
        padding-left: 2px;
    }

    .check-all {
        float: right;
        padding: 0;
    }

    .check-all /deep/ span {
        padding-right: 0;
        padding-left: 4px;
    }

    .pos-title {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .handle {
      cursor: move;
    }
</style>

<style>
    .any-user-tree > li:first-child {
        padding-top: 0 !important;
    }
</style>
